const CURRENT_TENANT_UUID_STORAGE_KEY = 'currentTenantUuid';
const CURRENT_USER_STORAGE_KEY = 'user';

export const saveCurrentTenantUuid = (tenantUuid?: string | null) => {
  try {
    if (tenantUuid) {
      localStorage.setItem(CURRENT_TENANT_UUID_STORAGE_KEY, tenantUuid);
      return;
    }
    localStorage.removeItem(CURRENT_TENANT_UUID_STORAGE_KEY);
  } catch {
    // ignore storage access errors
  }
};

export const readCurrentTenantUuid = () => {
  try {
    return localStorage.getItem(CURRENT_TENANT_UUID_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const saveCurrentSessionUser = (user: unknown) => {
  try {
    localStorage.setItem(CURRENT_USER_STORAGE_KEY, JSON.stringify(user));
  } catch {
    // Ignore unavailable browser storage; request headers also have an in-memory session fallback.
  }
};
